var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4986_65516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4961 2.28516H33.2987L32.9102 1.75781V0.878906C32.9102 0.393516 32.5166 0 32.0312 0C31.5459 0 31.1523 0.393516 31.1523 0.878906V1.75781L30.5873 2.28516H24.4902L24.1211 1.75781V0.878906C24.1211 0.393516 23.7276 0 23.2422 0C22.7568 0 22.3633 0.393516 22.3633 0.878906V1.75781L21.898 2.28516H15.7077L15.2734 1.75781V0.878906C15.2734 0.393516 14.8799 0 14.3945 0C13.9091 0 13.5156 0.393516 13.5156 0.878906V1.75781L13.0503 2.28516H12.4023L10 7.08984V25.5469C10 26.0323 10.3935 26.4258 10.8789 26.4258H35.5469C36.0323 26.4258 36.4258 26.0323 36.4258 25.5469V7.08984L33.4961 2.28516Z",
    fill: "url(#paint0_linear_4986_65516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4258 2.63672C36.4258 2.15133 36.0323 1.75781 35.5469 1.75781H32.9102V4.39453C32.9102 4.87992 32.5166 5.27344 32.0312 5.27344C31.5459 5.27344 31.1523 4.87992 31.1523 4.39453V1.75781H24.1211V4.39453C24.1211 4.87992 23.7276 5.27344 23.2422 5.27344C22.7568 5.27344 22.3633 4.87992 22.3633 4.39453V1.75781H15.2734V4.39453C15.2734 4.87992 14.8799 5.27344 14.3945 5.27344C13.9091 5.27344 13.5156 4.87992 13.5156 4.39453V1.75781H10.8789C10.3935 1.75781 10 2.15133 10 2.63672V7.08984H36.4258V2.63672ZM17.9102 10.6055H14.3945C13.9091 10.6055 13.5156 10.999 13.5156 11.4844V15C13.5156 15.4854 13.9091 15.8789 14.3945 15.8789H17.9102C18.3955 15.8789 18.7891 15.4854 18.7891 15V11.4844C18.7891 10.999 18.3955 10.6055 17.9102 10.6055ZM25 10.6055H21.4844C20.999 10.6055 20.6055 10.999 20.6055 11.4844V15C20.6055 15.4854 20.999 15.8789 21.4844 15.8789H25C25.4854 15.8789 25.8789 15.4854 25.8789 15V11.4844C25.8789 10.999 25.4854 10.6055 25 10.6055ZM28.5156 10.6055C28.0302 10.6055 27.6367 10.999 27.6367 11.4844V15C27.6367 15.4854 28.0302 15.8789 28.5156 15.8789H32.0312C32.5166 15.8789 32.9102 15.4854 32.9102 15V11.4844C32.9102 10.999 32.5166 10.6055 32.0312 10.6055H28.5156ZM25 17.6367H21.4844C20.999 17.6367 20.6055 18.0302 20.6055 18.5156V22.0312C20.6055 22.5166 20.999 22.9102 21.4844 22.9102H25C25.4854 22.9102 25.8789 22.5166 25.8789 22.0312V18.5156C25.8789 18.0302 25.4854 17.6367 25 17.6367ZM17.9102 17.6367H14.3945C13.9091 17.6367 13.5156 18.0302 13.5156 18.5156V22.0312C13.5156 22.5166 13.9091 22.9102 14.3945 22.9102H17.9102C18.3955 22.9102 18.7891 22.5166 18.7891 22.0312V18.5156C18.7891 18.0302 18.3955 17.6367 17.9102 17.6367ZM33.7891 17.6367C30.3967 17.6367 27.6367 20.3967 27.6367 23.7891C27.6367 27.2138 30.3967 30 33.7891 30C37.1966 30 40 27.1835 40 23.7891C40 20.3967 37.2138 17.6367 33.7891 17.6367ZM35.5469 24.668H33.7891C33.3037 24.668 32.9102 24.2745 32.9102 23.7891V22.0312C32.9102 21.5459 33.3037 21.1523 33.7891 21.1523C34.2745 21.1523 34.668 21.5459 34.668 22.0312V22.9102H35.5469C36.0323 22.9102 36.4258 23.3037 36.4258 23.7891C36.4258 24.2745 36.0323 24.668 35.5469 24.668Z",
    fill: "url(#paint1_linear_4986_65516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4986_65516",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4986_65516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4986_65516",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4986_65516",
    x1: 23.2129,
    y1: 26.4258,
    x2: 23.2129,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4986_65516",
    x1: 25,
    y1: 30,
    x2: 25,
    y2: 1.75781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a862890da58523ec8f3fee9a76aedccf.svg";
export { ForwardRef as ReactComponent };